/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Noachievementsforset3Inputs */

const id_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pencapaian ditemukan untuk set ini.`)
};

const ms_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada pencapaian ditemui untuk set ini.`)
};

const da_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen achievements fundet for dette sæt.`)
};

const de_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Errungenschaften für dieses Set gefunden.`)
};

const en_us2_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No achievements found for this set.`)
};

const es_es2_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron logros para este conjunto.`)
};

const es_mx2_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron logros para este conjunto.`)
};

const fil_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang achievement para sa set na ito.`)
};

const fr_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun succès trouvé pour cet ensemble.`)
};

const it_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato trovato per questo set.`)
};

const hu_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található teljesítmény ehhez a készlethez.`)
};

const nl_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen prestaties gevonden voor deze set.`)
};

const no_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen prestasjoner funnet for dette settet.`)
};

const pl_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono osiągnięć dla tego zestawu.`)
};

const pt_br2_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conquista encontrada para este conjunto.`)
};

const pt_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conquista encontrada para este conjunto.`)
};

const ro_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit realizări pentru acest set.`)
};

const fi_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tälle sarjalle ei löytynyt saavutuksia.`)
};

const sv_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga prestationer hittades för denna uppsättning.`)
};

const vi_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy thành tích cho bộ này.`)
};

const tr_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu set için başarım bulunamadı.`)
};

const cs_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tuto sadu nebyly nalezeny žádné úspěchy.`)
};

const bg_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени постижения за този набор.`)
};

const ru_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для этого набора достижения не найдены.`)
};

const uk_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для цього набору досягнень не знайдено.`)
};

const ar_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على إنجازات لهذه المجموعة.`)
};

const hi_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सेट के लिए कोई उपलब्धियाँ नहीं मिलीं।`)
};

const th_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบความสำเร็จสำหรับชุดนี้`)
};

const ja_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このセットの実績は見つかりません。`)
};

const zh_cn2_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此集合未找到成就。`)
};

const zh_hant1_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此集合未找到成就。`)
};

const ko_sandboxes_noachievementsforset3 = /** @type {(inputs: Sandboxes_Noachievementsforset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 세트에 도전 과제가 없습니다.`)
};

/**
* | output |
* | --- |
* | "No achievements found for this set." |
*
* @param {Sandboxes_Noachievementsforset3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_noachievementsforset3 = /** @type {((inputs?: Sandboxes_Noachievementsforset3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Noachievementsforset3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_noachievementsforset3(inputs)
	if (locale === "ms") return ms_sandboxes_noachievementsforset3(inputs)
	if (locale === "da") return da_sandboxes_noachievementsforset3(inputs)
	if (locale === "de") return de_sandboxes_noachievementsforset3(inputs)
	if (locale === "en-US") return en_us2_sandboxes_noachievementsforset3(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_noachievementsforset3(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_noachievementsforset3(inputs)
	if (locale === "fil") return fil_sandboxes_noachievementsforset3(inputs)
	if (locale === "fr") return fr_sandboxes_noachievementsforset3(inputs)
	if (locale === "it") return it_sandboxes_noachievementsforset3(inputs)
	if (locale === "hu") return hu_sandboxes_noachievementsforset3(inputs)
	if (locale === "nl") return nl_sandboxes_noachievementsforset3(inputs)
	if (locale === "no") return no_sandboxes_noachievementsforset3(inputs)
	if (locale === "pl") return pl_sandboxes_noachievementsforset3(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_noachievementsforset3(inputs)
	if (locale === "pt") return pt_sandboxes_noachievementsforset3(inputs)
	if (locale === "ro") return ro_sandboxes_noachievementsforset3(inputs)
	if (locale === "fi") return fi_sandboxes_noachievementsforset3(inputs)
	if (locale === "sv") return sv_sandboxes_noachievementsforset3(inputs)
	if (locale === "vi") return vi_sandboxes_noachievementsforset3(inputs)
	if (locale === "tr") return tr_sandboxes_noachievementsforset3(inputs)
	if (locale === "cs") return cs_sandboxes_noachievementsforset3(inputs)
	if (locale === "bg") return bg_sandboxes_noachievementsforset3(inputs)
	if (locale === "ru") return ru_sandboxes_noachievementsforset3(inputs)
	if (locale === "uk") return uk_sandboxes_noachievementsforset3(inputs)
	if (locale === "ar") return ar_sandboxes_noachievementsforset3(inputs)
	if (locale === "hi") return hi_sandboxes_noachievementsforset3(inputs)
	if (locale === "th") return th_sandboxes_noachievementsforset3(inputs)
	if (locale === "ja") return ja_sandboxes_noachievementsforset3(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_noachievementsforset3(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_noachievementsforset3(inputs)
	return ko_sandboxes_noachievementsforset3(inputs)
});
export { sandboxes_noachievementsforset3 as "sandboxes.noAchievementsForSet" }